import axios from "@/plugins/axios";
import jwt_decode from "jwt-decode";
import { isTokenValid, getValidToken } from "@/utils/auth";

const initialToken = getValidToken();

export const state = () => ({
  token: initialToken,
  status: !!initialToken,
  refreshToken: null,
  permissions: [],
  user: {
    username: null,
    usertype: null,
    waiter_id: null,
  },
});

export const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;

    if (token) {
      localStorage.setItem("jhms_token", token);
      try {
        const decoded = jwt_decode(token);
        state.user = {
          username: decoded.username || decoded.rese?.username || null,
          usertype: decoded.rese?.usertype || decoded.usertype || null,
          waiter_id: decoded.rese?.waiter_id || decoded.waiter_id || null,
        };
      } catch (err) {
        console.error("Error decoding token:", err);
      }
      return;
    }

    state.user = {
      username: null,
      usertype: null,
      waiter_id: null,
    };
    state.permissions = [];
    localStorage.removeItem("jhms_token");
  },

  SET_REFRESH_TOKEN(state, token) {
    state.refreshToken = token;
  },

  SET_USER(state, payload) {
    state.user = payload;
  },

  SET_STATUS(state, payload) {
    state.status = payload;
  },

  SET_PERMISSIONS(state, payload) {
    state.permissions = payload || [];
  },
};

export const actions = {
  async Login({ commit, dispatch }, credentials) {
    try {
      const res = await axios.post("auth/login", {
        ...credentials,
        portal: true,
      });

      if (res.data && res.data.chooseAccess) {
        return res;
      }

      const token = res.data.accessToken;
      const refreshToken = res.data.refreshToken;

      commit("SET_TOKEN", token);
      commit("SET_REFRESH_TOKEN", refreshToken);
      commit("SET_STATUS", true);
      dispatch("organization/fetchOrganization", null, { root: true });
      dispatch("fetchUserInfo").catch(() => {});

      const decoded = jwt_decode(token);
      const userType = decoded.rese?.usertype || decoded.usertype;

      return res;
    } catch (err) {
      console.error("Login error:", err);
      throw err;
    }
  },
  async LogOut({ commit }) {
    commit("SET_TOKEN", null);
    commit("SET_STATUS", false);
    return true;
  },

  // LogOut({ commit }) {
  //   commit("SET_USER", null);
  //   commit("SET_TOKEN", null);
  //   commit("SET_STATUS", false);
  //   localStorage.removeItem("jhms_token");
  //   this.$router.push("/login");
  // },

  async fetchUserInfo({ commit }) {
    try {
      const res = await axios.get("auth/user");
      const user = res.data;
      const policies = [];
      if (user && user.roles && user.roles.length) {
        user.roles.forEach((role) => {
          (role.policies || []).forEach((policy) => {
            if (policy.name && !policies.includes(policy.name)) {
              policies.push(policy.name);
            }
          });
        });
      }
      commit("SET_USER", {
        username: user.username,
        usertype: user.usertype,
        waiter_id: user.waiter_id || null,
        role: user.role || null,
      });
      commit("SET_PERMISSIONS", policies);
      return res;
    } catch (err) {
      console.error("Fetch user info error:", err);
      throw err;
    }
  },
};

export const getters = {
  GetUser: (state) => state.user,

  GetUserName: (state) => (state.user && state.user.username) || "",

  IsAuthenticated: (state) => isTokenValid(state.token),

  GetDecodedUser: (state) => {
    if (!state.token) return null;
    try {
      return jwt_decode(state.token);
    } catch (err) {
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
